import React, { Suspense } from "react";
import MessageBox from "../../Reusable/MessageBox/MessageBox.js";
import classNames from "classnames";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Image from "../../Elements/Image/Image.tsx";
import Filters from "components/Pages/Inbox/Content/Toolbar/Filters.tsx";
import useInboxQueryParams from "hooks/useInboxQueryParams.ts";
import useMediaQueries from "hooks/useMediaQueries.js";
import "./FullScreenMessage.scss";
import { useUser } from "../../../contexts/userContext/userContext.js";
import StatusFilterBar from "../../Pages/Inbox/Reusable/StatusFilterBar.tsx";
import hasAdminAccessRights from "../../../helpers/hasAdminAccessRights.ts";
import AdditionalSearchInfo from "components/Pages/Inbox/Content/AdditionalSearchInfo/index.tsx";

const FullScreenMessage = ({
  message,
  isUnmountOnExit,
  isShowOnStart,
  children,
}) => {
  const { getHtmlByKey } = useContent();
  const { getQueryParam } = useInboxQueryParams();
  const { desktopCondition } = useMediaQueries();
  const { getUserData } = useUser();

  //variables verification
  const image =
    message && message.data && message.data.image ? message.data.image : null;
  const topBox = message && message.data ? message.data.topBox : null;
  const title = message && message.data ? message.data.title : "";
  const content = message && message.data ? message.data.content : "";

  //component to show
  const Component =
    message && message.data && message.data.component
      ? typeof message.data.component === "function"
        ? message.data.component
        : React.lazy(() => import(`./${message.data.component}.js`))
      : null;

  //message style
  const innerContainerClasses = classNames([
    "full-screen-message-inner-container",
    message?.data?.center ? "flex-centered" : null,
  ]);
  const containerClasses = classNames([
    "full-screen-message-container",
    message?.data?.containerCenter ? "vertical-center" : "",
    "gray",
  ]);

  const showRecipientFilter =
    hasAdminAccessRights(
      getUserData()?.isTopUser,
      getUserData()?.subUserRole
    ) && getQueryParam("t") === "sent";

  return (
    <>
      <AnimationContainer
        animationOn={message && !!message.isShow}
        animationClassName={
          isShowOnStart
            ? "full-screen-message-animation fade-out"
            : "full-screen-message-animation fade-in"
        }
        containerElementClassName={isShowOnStart ? "fade-out" : "fade-in"}
        isUnmountOnExit={isUnmountOnExit ? isUnmountOnExit : true}
      >
        {(getQueryParam("sa") ||
          getQueryParam("sf") ||
          getQueryParam("sm") ||
          getQueryParam("ps") ||
          showRecipientFilter) &&
          desktopCondition &&
          !window.location.href.includes("manageStorage") && (
            <div className="no-data-filters-wrapper">
              <Filters />
              <StatusFilterBar />
            </div>
          )}
        <div className={containerClasses}>
          {topBox ? (
            <MessageBox
              textKey={topBox.text}
              icon={topBox.icon}
              backgroundColor={topBox.backgroundColor}
            />
          ) : null}
          <div className={innerContainerClasses}>
            {image ? (
              <Image
                className="full-screen-message-image"
                name={image.src}
                ext={image.ext}
                title={image.title}
                alt={image.alt}
              />
            ) : null}
            <div className="full-screen-message-content-container">
              {title ? (
                <div className="full-screen-message-title" name={title}>
                  {getHtmlByKey(title)}
                </div>
              ) : null}
              {content ? (
                <div className="full-screen-message-content" name={content}>
                  {getHtmlByKey(content)}
                </div>
              ) : null}
              {getQueryParam("q") ? <AdditionalSearchInfo /> : null}
              {Component ? (
                <Suspense>
                  <Component children={<></>}></Component>
                </Suspense>
              ) : null}
              {children}
            </div>
          </div>
        </div>
      </AnimationContainer>
    </>
  );
};

FullScreenMessage.defaultProps = {
  image: { src: "desktop-circled", ext: "svg", title: "", alt: "" },
  title: "",
  content: "",
};

export default FullScreenMessage;
